module.exports = __webpack_public_path__ + "static/media/royal-logo.99c6b53f.png";